import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import authGuard from "./auth-guard";
import { useAppStore } from "@/stores/appStore";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
    beforeEnter: authGuard,
  },
  {
    path: "/leave",
    name: "leave",
    component: () => import("../views/LeaveView.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/create-leave",
    name: "create-leave",
    component: () => import("../views/CreateLeave.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/leave-settings",
    name: "leave-settings",
    component: () => import("../views/LeaveSettings.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/leave-query",
    name: "leave-query",
    component: () => import("../views/LeaveQuery.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/leave-state",
    name: "leave-state",
    component: () => import("../views/LeaveState.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/sign",
    name: "sign",
    component: () => import("../views/SignView.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/sign/:wfType/:nid",
    name: "SignDetail",
    component: () => import("../views/SignDetail.vue"),
    props: (route) => ({
      nid: route.params.nid,
      wfType: route.params.wfType,
      reassignButton: route.query.reassignButton,
      dispinf: route.query.dispinf,
    }),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/notification",
    name: "NotificationCenter",
    components: {
      default: () => import("../views/NotificationCenter.vue"),
    },
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import("../views/SettingView.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/other",
    name: "other",
    component: () => import("../views/OtherView.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/erp",
    name: "erp",
    component: () => import("../views/ERPView.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/tree",
    name: "tree",
    component: () => import("../views/TreeLayout.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/RegisterView.vue"),
    // beforeEnter: authGuard,
  },
  {
    path: "/frequent",
    name: "frequent",
    component: () => import("../views/FrequentList.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/device-state",
    name: "device-state",
    component: () => import("../views/DeviceState.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/chat",
    name: "chat",
    component: () => import("../views/ChatView.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/notes-board",
    name: "notes-board",
    component: () => import("../views/NotesBoard.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/at-message",
    name: "at-message",
    component: () => import("../views/AtMessage.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/message-notify",
    name: "message-notify",
    component: () => import("../views/MessageNotify.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/message-record",
    name: "message-record",
    component: () => import("../views/MessageRecord.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/salary-login",
    name: "salary-login",
    component: () => import("../views/SalaryLogin.vue"),
    meta: {
      requireAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/salary-view",
    name: "salary-view",
    component: () => import("../views/SalaryView.vue"),
    meta: {
      requireAuth: true,
      requireSalaryAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/salary-income",
    name: "salary-income",
    component: () => import("../views/SalaryIncome.vue"),
    meta: {
      requireAuth: true,
      requireSalaryAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/yearend-bonus",
    name: "yearend-bonus",
    component: () => import("../views/YearendBonus.vue"),
    meta: {
      requireAuth: true,
      requireSalaryAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/performance-bonus",
    name: "performance-bonus",
    component: () => import("../views/PerformanceBonus.vue"),
    meta: {
      requireAuth: true,
      requireSalaryAuth: true,
    },
    beforeEnter: authGuard,
  },
  {
    path: "/annual-income",
    name: "annual-income",
    component: () => import("../views/AnnualIncome.vue"),
    meta: {
      requireAuth: true,
      requireSalaryAuth: true,
    },
    beforeEnter: authGuard,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach(authGuard);

function onLogEvent(navDrawerListsNew, to) {
  const flattenedArray = flattenArray(navDrawerListsNew);

  let pageDetail = null;
  if (to.fullPath == "/") {
    pageDetail = {
      name: "首頁",
    };
  } else if (to.fullPath == "/salary-login") {
    pageDetail = {
      name: "薪資登入",
    };
  } else if (to.fullPath == "/login") {
    pageDetail = {
      name: "登入",
    };
  } else if (to.fullPath == "/notes-board") {
    pageDetail = {
      name: "網路佈告欄",
    };
  } else if (to.fullPath == "/device-state") {
    pageDetail = {
      name: "裝置版本",
    };
  } else if (to.fullPath.includes("/sign") && to.fullPath !== "/sign") {
    pageDetail = {
      name: "簽核明細",
    };
  } else {
    pageDetail = flattenedArray.find((e) => e.url == to.fullPath)
      ? flattenedArray.find((e) => e.url == to.fullPath)
      : {
          name: "無法取得名稱",
        };
  }

  let pageName = `${to.name} ${pageDetail.name}`;

  if (window.EipJSInterface && window.EipJSInterface.onLogEvent) {
    window.EipJSInterface.onLogEvent(
      JSON.stringify({
        pageName: pageName,
      })
    );
  }
}

function flattenArray(arr) {
  return arr.reduce((acc, cur) => {
    acc.push(cur);
    if (cur.children) {
      acc = acc.concat(flattenArray(cur.children));
    }
    return acc;
  }, []);
}

router.afterEach((to) => {
  const store = useAppStore();
  onLogEvent(store.navDrawerListsNew, to);
});

export default router;
